(function () {

  console.log('[ImageSwitcher] 🚀 Script loaded');

  let _correctImageUrl  = null;
  let _correctZoomUrl   = null;
  let _correctAltText   = null;
  let _observer         = null;
  let _isUpdating       = false;
  let _thumbClicked     = false;
  let _slickSettings    = null;
  let _prefetched       = false;

  // ─── READ CURRENT DROPDOWN SELECTION ───────────────────────────────────────
  function getSelectedCombo() {
    const shape = document.querySelector('.option-supported-shapes select')?.value;
    const metal = document.querySelector('.option-metal-color select')?.value;
    const carat = document.querySelector('.option-head-sizes select')?.value;
    return { shape, metal, carat };
  }

  // ─── GET PRODUCT OPTIONS OBJECT DYNAMICALLY ─────────────────────────────────
  function getProductOptionsObject() {
    const optionsKey = Object.keys(window).find(key => key.startsWith('product_options_'));
    if (optionsKey) return window[optionsKey];

    const productIdInput = document.querySelector('input[name="product-id"]');
    if (productIdInput) {
      const varName = 'product_options_' + productIdInput.value;
      if (window[varName]) return window[varName];
    }

    const form = document.querySelector('form[id^="product_form_"]');
    if (form) {
      const varName = 'product_options_' + form.id.replace('product_form_', '');
      if (window[varName]) return window[varName];
    }

    console.error('[ImageSwitcher] ❌ Could not find product_options_XXXX object');
    return null;
  }

  // ─── FETCH VARIANT DATA ──────────────────────────────────────────────────────
  function getVariantData(shape, metal, carat) {
    const productOptions = getProductOptionsObject();
    if (!productOptions) return null;
    if (!productOptions[shape]?.[metal]?.[carat]) return null;
    return productOptions[shape][metal][carat];
  }

  // ─── FORMAT PRICE ────────────────────────────────────────────────────────────
  function formatPrice(cents) {
    const amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ─── UPDATE PRICE IN DOM ─────────────────────────────────────────────────────
  function updatePriceDisplay(variantData) {
    if (!variantData) return;

    const price          = variantData.price;
    const compareAtPrice = variantData.compare_at_price;
    const formattedPrice = formatPrice(price);

    document.querySelectorAll('.special-price').forEach(el => {
      el.textContent = formattedPrice + ' USD';
    });

    const compareSelectors = [
      '.product-single__price--compare',
      '.price__compare',
      '[data-compare-price]',
      '.compare-at-price',
    ];

    compareSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (compareAtPrice) {
          el.textContent = formatPrice(compareAtPrice);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    });
  }

  // ─── UPDATE HIDDEN INPUT [name="id"] ────────────────────────────────────────
  function updateVariantInput(variantId) {
    if (!variantId) return false;

    const variantInput = document.querySelector('input[name="id"]')
                      || document.querySelector('[name="id"]');
    if (!variantInput) return false;

    if (variantInput.value === String(variantId)) return true;

    const oldValue = variantInput.value;
    variantInput.value = variantId;
    console.log('[ImageSwitcher] 🔄 Variant input updated:', oldValue, '→', variantId);

    ['change', 'input'].forEach(type => {
      variantInput.dispatchEvent(new Event(type, { bubbles: true }));
    });

    document.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: { variantId }
    }));

    return true;
  }

  // ─── SYNC VARIANT ID + PRICE ─────────────────────────────────────────────────
  function syncVariantId(shape, metal, carat) {
    const variantData = getVariantData(shape, metal, carat);
    if (!variantData) {
      console.error('[ImageSwitcher] ❌ Variant data not found');
      return;
    }
    updateVariantInput(variantData['id']);
    updatePriceDisplay(variantData);
  }

  // ─── PREFETCH ALL GALLERY IMAGES (warms browser cache) ──────────────────────
  // Runs once. After this, swapping images is near-instant because the browser
  // already has them cached.
  function prefetchAllImages() {
    if (_prefetched) return;
    _prefetched = true;

    const anchors = document.querySelectorAll('#previewsGallery > a[data-image]');
    console.log('[ImageSwitcher] 📥 Prefetching', anchors.length, 'gallery images');

    anchors.forEach(a => {
      const url = a.getAttribute('data-image');
      if (url) {
        const img = new Image();
        img.src = url.replace(/^\/\//, 'https://');
      }
    });
  }

  // ─── STORE ORIGINAL SLICK SETTINGS ─────────────────────────────────────────
  function captureSlickSettings() {
    if (typeof $ === 'undefined') return;
    const $gallery = $('#previewsGallery');
    if ($gallery.hasClass('slick-initialized')) {
      _slickSettings = $gallery.slick('getSlick').options;
    }
  }

  // ─── FILTER GALLERY SLIDES BASED ON SELECTION ───────────────────────────────
  // Uses slickFilter / slickUnfilter instead of unslick + reinit.
  // This avoids the expensive full teardown of the carousel on every change.
  function filterGallerySlides() {
    const { shape, metal, carat } = getSelectedCombo();
    if (!shape || !metal || !carat) return;
    if (typeof $ === 'undefined') return;

    const $gallery = $('#previewsGallery');
    if (!$gallery.length) return;

    const s = shape.toLowerCase();
    const m = metal.toLowerCase();
    const c = carat.toLowerCase();

    const matchFn = function () {
      const img = this.querySelector('img');
      if (!img || !img.alt) return false;
      const alt = img.alt.toLowerCase();
      return alt.includes(s) && alt.includes(m) && alt.includes(c);
    };

    if ($gallery.hasClass('slick-initialized')) {
      // Clear any previous filter, then apply the new one — no destroy/reinit.
      try { $gallery.slick('slickUnfilter'); } catch (e) {}
      $gallery.slick('slickFilter', matchFn);
      console.log('[ImageSwitcher] 🔄 Gallery filtered via slickFilter');
    } else {
      // Fallback: gallery not initialized as slick — hide raw <a> items.
      $gallery.find('> a').toArray().forEach(function (item) {
        const img = item.querySelector('img');
        item.style.display = (img && img.alt && matchFn.call(item)) ? '' : 'none';
      });
    }

    // Filter mobile thumbnails (plain show/hide, no carousel here)
    document.querySelectorAll('.thumbnails-wrapper-mobile a').forEach(function (thumb) {
      const img = thumb.querySelector('img');
      if (!img || !img.alt) { thumb.style.display = 'none'; return; }
      const alt = img.alt.toLowerCase();
      thumb.style.display = (alt.includes(s) && alt.includes(m) && alt.includes(c)) ? '' : 'none';
    });
  }

  // ─── FIND MATCHING SLIDE ────────────────────────────────────────────────────
  function findSlideByAlt(altKey) {
    const slides = document.querySelectorAll('#previewsGallery .slick-slide:not([style*="display: none"]):not([style*="display:none"])');
    const allItems = slides.length > 0
      ? slides
      : document.querySelectorAll('#previewsGallery > a[style=""], #previewsGallery > a:not([style])');

    const keyWords = altKey.toLowerCase().split('-').filter(Boolean);

    let bestMatch = null;
    let bestScore = 0;

    for (const slide of allItems) {
      const img = slide.querySelector('img');
      if (!img || !img.alt) continue;

      const slideWords   = img.alt.toLowerCase().split('-').filter(Boolean);
      const matchedWords = keyWords.filter(word => slideWords.includes(word));
      const score        = matchedWords.length;

      if (score === keyWords.length && slideWords.length === keyWords.length) return slide;
      if (score > bestScore) { bestScore = score; bestMatch = slide; }
    }

    if (bestMatch && bestScore === keyWords.length) return bestMatch;
    console.warn('[ImageSwitcher] ❌ No slide match for:', keyWords);
    return null;
  }

  // ─── APPLY ZOOM + LINKS (runs after the main src is confirmed) ───────────────
  function applyZoomAndLinks(mainImg, fullZoom) {
    const zoomLink = document.querySelector('#main_image_container .zoom-link');
    if (zoomLink) zoomLink.href = fullZoom;

    const zoomBGImage = document.querySelector('#main_image_container .zoomWindowContainer');
    if (zoomBGImage) {
      zoomBGImage.style.backgroundImage = `url('${fullZoom}')`;
      const innerDiv = zoomBGImage.querySelector('div');
      if (innerDiv) innerDiv.style.backgroundImage = `url('${fullZoom}')`;
    }

    if (typeof window.schubachInitVdbZoom === 'function') {
      window.setTimeout(window.schubachInitVdbZoom, 50);
    } else if (typeof $ !== 'undefined') {
      try {
        const $img = $(mainImg);
        $img.trigger('zoom.destroy');
        if (typeof $img.zoom === 'function') $img.zoom({ url: fullZoom });
      } catch (e) {
        console.warn('[ImageSwitcher] ⚠️ Zoom plugin error:', e.message);
      }
    }
  }

  // ─── CORE: APPLY IMAGE TO DOM (with preloading) ─────────────────────────────
  // Preloads the target image OFF-SCREEN first, then swaps src only once it's
  // decoded and ready — so the visible image changes instantly with no blank gap.
  function applyImageToDom(imageUrl, zoomUrl, altText) {
    if (!imageUrl) return;

    const fullSrc  = imageUrl.replace(/^\/\//, 'https://');
    const fullZoom = (zoomUrl || imageUrl).replace(/^\/\//, 'https://');

    const mainImg = document.querySelector('#main_image_container .zoom')
                 || document.querySelector('#main_image_container img');
    if (!mainImg) return;
    if (mainImg.src === fullSrc) return;

    const doSwap = function () {
      _isUpdating = true;
      mainImg.setAttribute('src', fullSrc);
      mainImg.src = fullSrc;
      if (altText) mainImg.alt = altText;
      applyZoomAndLinks(mainImg, fullZoom);
      console.log('[ImageSwitcher] 🖼️ Image applied:', fullSrc);
      setTimeout(function () { _isUpdating = false; }, 100);
    };

    const pre = new Image();
    pre.onload  = doSwap;
    pre.onerror = doSwap; // swap anyway so we never get stuck on a failed preload
    pre.src = fullSrc;

    // If the browser already has it cached, onload may not fire reliably in
    // some browsers — this guarantees an immediate swap when it's complete.
    if (pre.complete) doSwap();
  }

  // ─── START MUTATION OBSERVER ────────────────────────────────────────────────
  function startObserver() {
    const mainImg = document.querySelector('#main_image_container .zoom')
                 || document.querySelector('#main_image_container img');
    if (!mainImg) return;

    if (_observer) _observer.disconnect();

    _observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'src') return;

        if (_isUpdating)   return; // our own change
        if (_thumbClicked) return; // user clicked a thumbnail — allow it

        const newSrc = mainImg.getAttribute('src');
        if (_correctImageUrl) {
          const fullCorrect = _correctImageUrl.replace(/^\/\//, 'https://');
          if (newSrc !== fullCorrect) {
            console.log('[ImageSwitcher] 🔁 Theme reset detected — restoring correct image');
            applyImageToDom(_correctImageUrl, _correctZoomUrl, _correctAltText);
          }
        }
      });
    });

    _observer.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    console.log('[ImageSwitcher] 👁️ Observer started');
  }

  // ─── ATTACH THUMBNAIL CLICK LISTENERS ───────────────────────────────────────
  function attachThumbnailListeners() {
    const gallery = document.querySelector('#previewsGallery');
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        const slide = e.target.closest('.slick-slide, a[data-image]');
        if (!slide) return;

        _thumbClicked = true;

        const clickedImage = slide.getAttribute('data-image')
                          || slide.querySelector('img')?.src;
        const clickedZoom  = slide.getAttribute('data-zoom-image') || clickedImage;
        const clickedAlt   = slide.querySelector('img')?.alt || '';

        if (clickedImage) {
          _correctImageUrl = clickedImage;
          _correctZoomUrl  = clickedZoom;
          _correctAltText  = clickedAlt;
        }

        setTimeout(function () { _thumbClicked = false; }, 500);
      });
    } else {
      console.warn('[ImageSwitcher] ⚠️ #previewsGallery not found for thumb listeners');
    }

    const mobileThumbs = document.querySelector('.thumbnails-wrapper-mobile');
    if (mobileThumbs) {
      mobileThumbs.addEventListener('click', function (e) {
        const thumb = e.target.closest('a[data-image]');
        if (!thumb) return;

        _thumbClicked = true;

        const clickedImage = thumb.getAttribute('data-image');
        const clickedZoom  = thumb.getAttribute('data-zoom-image') || clickedImage;
        const clickedAlt   = thumb.querySelector('img')?.alt || '';

        if (clickedImage) {
          _correctImageUrl = clickedImage;
          _correctZoomUrl  = clickedZoom;
          _correctAltText  = clickedAlt;
        }

        setTimeout(function () { _thumbClicked = false; }, 500);
      });
    }

    console.log('[ImageSwitcher] 👂 Thumbnail click listeners attached');
  }

  // ─── MAIN UPDATE ────────────────────────────────────────────────────────────
  function updateImageFromSelection() {
    const { shape, metal, carat } = getSelectedCombo();
    if (!shape || !metal || !carat) {
      console.error('[ImageSwitcher] ❌ Missing dropdown value');
      return;
    }

    // 1. Sync variant ID + price
    syncVariantId(shape, metal, carat);

    // 2. Find matching slide and update image
    const altKey = `${metal}-${shape}-${carat}`;
    const slide  = findSlideByAlt(altKey);
    if (!slide) return;

    const imageUrl = slide.getAttribute('data-image');
    const zoomUrl  = slide.getAttribute('data-zoom-image');
    const imgEl    = slide.querySelector('img');
    const altText  = imgEl?.alt || altKey;

    _correctImageUrl = imageUrl;
    _correctZoomUrl  = zoomUrl;
    _correctAltText  = altText;

    // Preload handles the timing — one immediate call + one safety net is enough.
    applyImageToDom(imageUrl, zoomUrl, altText);
    setTimeout(() => applyImageToDom(imageUrl, zoomUrl, altText), 200);
  }

  // ─── PATCH setPrice() ───────────────────────────────────────────────────────
  function patchSetPrice() {
    if (typeof window.setPrice === 'function') {
      window._originalSetPrice = window.setPrice;
      window._patchedSetPrice  = true;
      window.setPrice = function () {
        window._originalSetPrice.apply(this, arguments);
        setTimeout(updateImageFromSelection, 30);
      };
      console.log('[ImageSwitcher] ✅ setPrice() patched');
    } else {
      setTimeout(patchSetPrice, 200);
    }
  }

  // ─── PATCH updateData() ─────────────────────────────────────────────────────
  function patchUpdateData() {
    if (typeof window.updateData === 'function') {
      const _original = window.updateData;
      window.updateData = function () {
        _original.apply(this, arguments);
        setTimeout(updateImageFromSelection, 30);
      };
      console.log('[ImageSwitcher] ✅ updateData() patched');
    } else {
      console.warn('[ImageSwitcher] ⚠️ updateData() not found');
    }
  }

  // ─── ATTACH DROPDOWN LISTENERS ──────────────────────────────────────────────
  function attachDropdownListeners() {
    const selectors = [
      '.option-supported-shapes select',
      '.option-metal-color select',
      '.option-head-sizes select'
    ];
    selectors.forEach(sel => {
      const el = document.querySelector(sel);
      if (el) {
        el.addEventListener('change', function (e) {
          console.log('[ImageSwitcher] 🖱️ Dropdown changed:', sel, '→', e.target.value);
          _thumbClicked = false;
          updateImageFromSelection();
          filterGallerySlides();
        });
      } else {
        console.error('[ImageSwitcher] ❌ Not found:', sel);
      }
    });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────────
  function init() {
    patchSetPrice();
    patchUpdateData();
    attachDropdownListeners();
    attachThumbnailListeners();
    startObserver();

    setTimeout(function () {
      captureSlickSettings();
      prefetchAllImages();      // warm the cache once, up front
      updateImageFromSelection();
      filterGallerySlides();
      startObserver();
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 300);
  }

  // ─── EXPOSE DEBUG TOOLS ──────────────────────────────────────────────────────
  window.ImageSwitcherDebug = {
    update:        updateImageFromSelection,
    filterGallery: filterGallerySlides,
    prefetch:      prefetchAllImages,
    startWatch:    startObserver,
    getStored:     () => ({ url: _correctImageUrl, zoom: _correctZoomUrl, alt: _correctAltText }),
    getVariant:    () => document.querySelector('input[name="id"]')?.value,
    lookupId:      (shape, metal, carat) => getVariantData(shape, metal, carat),
    testPrice:     (shape, metal, carat) => updatePriceDisplay(getVariantData(shape, metal, carat)),
  };

})();

// (function () {

//   console.log('[ImageSwitcher] 🚀 Script loaded');

//   let _correctImageUrl  = null;
//   let _correctZoomUrl   = null;
//   let _correctAltText   = null;
//   let _observer         = null;
//   let _isUpdating       = false;
//   let _thumbClicked     = false; // ← NEW: flag to pause observer on thumb click

//   // ─── READ CURRENT DROPDOWN SELECTION ───────────────────────────────────────
//   function getSelectedCombo() {
//     const shape = document.querySelector('.option-supported-shapes select')?.value;
//     const metal = document.querySelector('.option-metal-color select')?.value;
//     const carat = document.querySelector('.option-head-sizes select')?.value;
//     console.log('[ImageSwitcher] 📋 Selection:', { shape, metal, carat });
//     return { shape, metal, carat };
//   }

//   // ─── GET PRODUCT OPTIONS OBJECT DYNAMICALLY ─────────────────────────────────
//   function getProductOptionsObject() {
//     const optionsKey = Object.keys(window).find(key => key.startsWith('product_options_'));
//     if (optionsKey) return window[optionsKey];

//     const productIdInput = document.querySelector('input[name="product-id"]');
//     if (productIdInput) {
//       const varName = 'product_options_' + productIdInput.value;
//       if (window[varName]) return window[varName];
//     }

//     const form = document.querySelector('form[id^="product_form_"]');
//     if (form) {
//       const varName = 'product_options_' + form.id.replace('product_form_', '');
//       if (window[varName]) return window[varName];
//     }

//     console.error('[ImageSwitcher] ❌ Could not find product_options_XXXX object');
//     return null;
//   }

//   // ─── FETCH VARIANT DATA ──────────────────────────────────────────────────────
//   function getVariantData(shape, metal, carat) {
//     const productOptions = getProductOptionsObject();
//     if (!productOptions) return null;
//     if (!productOptions[shape]?.[metal]?.[carat]) return null;
//     return productOptions[shape][metal][carat];
//   }

//   // ─── FORMAT PRICE ────────────────────────────────────────────────────────────
//   function formatPrice(cents) {
//     const amount = (cents / 100).toFixed(2);
//     return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   }

//   // ─── UPDATE PRICE IN DOM ─────────────────────────────────────────────────────
//   function updatePriceDisplay(variantData) {
//     if (!variantData) return;

//     const price          = variantData.price;
//     const compareAtPrice = variantData.compare_at_price;
//     const formattedPrice = formatPrice(price);

//     console.log('[ImageSwitcher] 💰 Updating price:', formattedPrice);

//     document.querySelectorAll('.special-price').forEach(el => {
//       el.textContent = formattedPrice + ' USD';
//       console.log('[ImageSwitcher] ✅ Price updated in .special-price');
//     });

//     const compareSelectors = [
//       '.product-single__price--compare',
//       '.price__compare',
//       '[data-compare-price]',
//       '.compare-at-price',
//     ];

//     compareSelectors.forEach(sel => {
//       document.querySelectorAll(sel).forEach(el => {
//         if (compareAtPrice) {
//           el.textContent = formatPrice(compareAtPrice);
//           el.style.display = '';
//         } else {
//           el.style.display = 'none';
//         }
//       });
//     });
//   }

//   // ─── UPDATE HIDDEN INPUT [name="id"] ────────────────────────────────────────
//   function updateVariantInput(variantId) {
//     if (!variantId) return false;

//     const variantInput = document.querySelector('input[name="id"]')
//                       || document.querySelector('[name="id"]');
//     if (!variantInput) return false;

//     const oldValue = variantInput.value;
//     if (oldValue === String(variantId)) {
//       console.log('[ImageSwitcher] ✅ Variant input already correct:', variantId);
//       return true;
//     }

//     variantInput.value = variantId;
//     console.log('[ImageSwitcher] 🔄 Variant input updated:', oldValue, '→', variantId);

//     ['change', 'input'].forEach(type => {
//       variantInput.dispatchEvent(new Event(type, { bubbles: true }));
//     });

//     document.dispatchEvent(new CustomEvent('variant:changed', {
//       bubbles: true,
//       detail: { variantId }
//     }));

//     return true;
//   }

//   // ─── SYNC VARIANT ID + PRICE ─────────────────────────────────────────────────
//   function syncVariantId(shape, metal, carat) {
//     const variantData = getVariantData(shape, metal, carat);
//     if (!variantData) {
//       console.error('[ImageSwitcher] ❌ Variant data not found');
//       return;
//     }
//     updateVariantInput(variantData['id']);
//     updatePriceDisplay(variantData);
//   }

//   // ─── STORE ORIGINAL SLICK SETTINGS ─────────────────────────────────────────
//   let _slickSettings = null;

//   function captureSlickSettings() {
//     if (typeof $ === 'undefined') return;
//     const $gallery = $('#previewsGallery');
//     if ($gallery.hasClass('slick-initialized')) {
//       _slickSettings = $gallery.slick('getSlick').options;
//       console.log('[ImageSwitcher] 📦 Slick settings captured:', _slickSettings);
//     }
//   }

//   // ─── FILTER GALLERY SLIDES BASED ON SELECTION ───────────────────────────────
//   function filterGallerySlides() {
//     const { shape, metal, carat } = getSelectedCombo();
//     if (!shape || !metal || !carat) return;

//     console.log('[ImageSwitcher] 🔍 Filtering gallery for:', { shape, metal, carat });

//     if (typeof $ === 'undefined') return;

//     const $gallery = $('#previewsGallery');

//     // Step 1 — Capture slick settings before destroying
//     if (_slickSettings === null) captureSlickSettings();

//     // Step 2 — Unslick so we get back original <a> elements
//     if ($gallery.hasClass('slick-initialized')) {
//       $gallery.slick('unslick');
//       console.log('[ImageSwitcher] 💥 Slick destroyed');
//     }

//     // Step 3 — Show/hide original <a> items (not .slick-slide)
//     const allItems = $gallery.find('> a').toArray();
//     console.log('[ImageSwitcher] 📋 Total items:', allItems.length);

//     allItems.forEach(function(item) {
//       const img = item.querySelector('img');
//       if (!img || !img.alt) {
//         item.style.display = 'none';
//         return;
//       }

//       const alt = img.alt.toLowerCase();
//       const shapeMatch = alt.includes(shape.toLowerCase());
//       const metalMatch = alt.includes(metal.toLowerCase());
//       const caratMatch = alt.includes(carat.toLowerCase());

//       if (shapeMatch && metalMatch && caratMatch) {
//         item.style.display = '';
//         console.log('[ImageSwitcher] ✅ Visible:', img.alt);
//       } else {
//         item.style.display = 'none';
//         console.log('[ImageSwitcher] ❌ Hidden:', img.alt);
//       }
//     });

//     // Step 4 — Reinitialize Slick with same settings
//     const settings = _slickSettings || {
//       slidesToShow: 4,
//       slidesToScroll: 1,
//       infinite: false,
//       arrows: true,
//       dots: false
//     };

//     // Remove internal slick keys that cause issues on reinit
//     const cleanSettings = Object.assign({}, settings);
//     delete cleanSettings.respondTo;

//     $gallery.slick(cleanSettings);
//     console.log('[ImageSwitcher] 🔄 Slick reinitialized');

//     // Step 5 — Filter mobile thumbnails
//     document.querySelectorAll('.thumbnails-wrapper-mobile a').forEach(function(thumb) {
//       const img = thumb.querySelector('img');
//       if (!img || !img.alt) { thumb.style.display = 'none'; return; }

//       const alt = img.alt.toLowerCase();
//       const match = alt.includes(shape.toLowerCase())
//                  && alt.includes(metal.toLowerCase())
//                  && alt.includes(carat.toLowerCase());

//       thumb.style.display = match ? '' : 'none';
//     });

//     console.log('[ImageSwitcher] ✅ Gallery filtered and slider reloaded');
//   }

//   // ─── FIND MATCHING SLIDE ────────────────────────────────────────────────────
//   function findSlideByAlt(altKey) {
//     // Check .slick-slide first, fallback to original <a> items
//     const slides = document.querySelectorAll('#previewsGallery .slick-slide:not([style*="display: none"]):not([style*="display:none"])');
//     const allItems = slides.length > 0
//       ? slides
//       : document.querySelectorAll('#previewsGallery > a[style=""], #previewsGallery > a:not([style])');

//     const keyWords = altKey.toLowerCase().split('-').filter(Boolean);

//     let bestMatch = null;
//     let bestScore = 0;

//     for (const slide of allItems) {
//       const img = slide.querySelector('img');
//       if (!img || !img.alt) continue;

//       const slideWords   = img.alt.toLowerCase().split('-').filter(Boolean);
//       const matchedWords = keyWords.filter(word => slideWords.includes(word));
//       const score        = matchedWords.length;

//       if (score === keyWords.length && slideWords.length === keyWords.length) return slide;
//       if (score > bestScore) { bestScore = score; bestMatch = slide; }
//     }

//     if (bestMatch && bestScore === keyWords.length) return bestMatch;
//     console.warn('[ImageSwitcher] ❌ No slide match for:', keyWords);
//     return null;
//   }

//   // ─── CORE: APPLY IMAGE TO DOM ───────────────────────────────────────────────
//   function applyImageToDom(imageUrl, zoomUrl, altText) {
//     if (!imageUrl) return;

//     const fullSrc  = imageUrl.replace(/^\/\//, 'https://');
//     const fullZoom = (zoomUrl || imageUrl).replace(/^\/\//, 'https://');

//     const mainImg = document.querySelector('#main_image_container .zoom')
//                  || document.querySelector('#main_image_container img');
//     if (!mainImg) return;
//     if (mainImg.src === fullSrc) return;

//     console.log('[ImageSwitcher] 🖼️ Applying image:', fullSrc);

//     _isUpdating = true;
//     mainImg.setAttribute('src', fullSrc);
//     mainImg.src = fullSrc;
//     if (altText) mainImg.alt = altText;

//     const zoomLink = document.querySelector('#main_image_container .zoom-link');
//     if (zoomLink) zoomLink.href = fullZoom;

//     const zoomBGImage = document.querySelector('#main_image_container .zoomWindowContainer');
//     if (zoomBGImage) {
//       zoomBGImage.style.backgroundImage = `url('${fullZoom}')`;
//       const innerDiv = zoomBGImage.querySelector('div');
//       if (innerDiv) innerDiv.style.backgroundImage = `url('${fullZoom}')`;
//     }

//     if (typeof $ !== 'undefined') {
//       try {
//         const $img = $(mainImg);
//         $img.trigger('zoom.destroy');
//         $img.zoom({ url: fullZoom });
//       } catch (e) {
//         console.warn('[ImageSwitcher] ⚠️ Zoom plugin error:', e.message);
//       }
//     }

//     setTimeout(function () { _isUpdating = false; }, 100);
//   }

//   // ─── START MUTATION OBSERVER ────────────────────────────────────────────────
//   function startObserver() {
//     const mainImg = document.querySelector('#main_image_container .zoom')
//                  || document.querySelector('#main_image_container img');
//     if (!mainImg) return;

//     if (_observer) _observer.disconnect();

//     _observer = new MutationObserver(function (mutations) {
//       mutations.forEach(function (mutation) {
//         if (mutation.attributeName !== 'src') return;

//         // ── Ignore if WE changed the src ──
//         if (_isUpdating) {
//           console.log('[ImageSwitcher] 👁️ Observer: our change — ignoring');
//           return;
//         }

//         // ── Ignore if user clicked a thumbnail ──────────────────────────────
//         // Thumbnail clicks are VALID — user wants to see a different image
//         // Do NOT override them
//         if (_thumbClicked) {
//           console.log('[ImageSwitcher] 👁️ Observer: thumbnail click — allowing');
//           return;
//         }

//         // ── External override (theme reset) — restore our correct image ──────
//         const newSrc = mainImg.getAttribute('src');
//         console.warn('[ImageSwitcher] 🚨 Observer: theme reset detected → newSrc:', newSrc);

//         if (_correctImageUrl) {
//           const fullCorrect = _correctImageUrl.replace(/^\/\//, 'https://');
//           if (newSrc !== fullCorrect) {
//             console.log('[ImageSwitcher] 🔁 Restoring correct image...');
//             setTimeout(() => applyImageToDom(_correctImageUrl, _correctZoomUrl, _correctAltText), 50);
//           }
//         }
//       });
//     });

//     _observer.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
//     console.log('[ImageSwitcher] 👁️ Observer started');
//   }

//   // ─── ATTACH THUMBNAIL CLICK LISTENERS ───────────────────────────────────────
//   // When user clicks a thumbnail, set _thumbClicked = true so observer
//   // does NOT fight the theme's image update from the click
//   function attachThumbnailListeners() {
//     const gallery = document.querySelector('#previewsGallery');
//     if (!gallery) {
//       console.warn('[ImageSwitcher] ⚠️ #previewsGallery not found for thumb listeners');
//       return;
//     }

//     // Use event delegation on the gallery container
//     gallery.addEventListener('click', function (e) {
//       const slide = e.target.closest('.slick-slide, a[data-image]');
//       if (!slide) return;

//       console.log('[ImageSwitcher] 🖼️ Thumbnail clicked — pausing observer');

//       // Set flag — observer will allow this image change
//       _thumbClicked = true;

//       // Also update _correctImageUrl to the thumbnail the user clicked
//       // so if the theme later resets it, we restore THIS image not the old one
//       const clickedImage    = slide.getAttribute('data-image')
//                            || slide.querySelector('img')?.src;
//       const clickedZoom     = slide.getAttribute('data-zoom-image') || clickedImage;
//       const clickedAlt      = slide.querySelector('img')?.alt || '';

//       if (clickedImage) {
//         _correctImageUrl = clickedImage;
//         _correctZoomUrl  = clickedZoom;
//         _correctAltText  = clickedAlt;
//         console.log('[ImageSwitcher] 📌 Correct image updated to thumb click:', clickedImage);
//       }

//       // Reset flag after a short delay — long enough for theme to finish
//       setTimeout(function () {
//         _thumbClicked = false;
//         console.log('[ImageSwitcher] 👁️ Observer re-enabled after thumbnail click');
//       }, 500);
//     });

//     // Also listen on mobile thumbnails
//     const mobileThumbs = document.querySelector('.thumbnails-wrapper-mobile');
//     if (mobileThumbs) {
//       mobileThumbs.addEventListener('click', function (e) {
//         const thumb = e.target.closest('a[data-image]');
//         if (!thumb) return;

//         console.log('[ImageSwitcher] 📱 Mobile thumbnail clicked');
//         _thumbClicked = true;

//         const clickedImage = thumb.getAttribute('data-image');
//         const clickedZoom  = thumb.getAttribute('data-zoom-image') || clickedImage;
//         const clickedAlt   = thumb.querySelector('img')?.alt || '';

//         if (clickedImage) {
//           _correctImageUrl = clickedImage;
//           _correctZoomUrl  = clickedZoom;
//           _correctAltText  = clickedAlt;
//         }

//         setTimeout(function () { _thumbClicked = false; }, 500);
//       });
//     }

//     console.log('[ImageSwitcher] 👂 Thumbnail click listeners attached');
//   }

//   // ─── SET ACTIVE THUMBNAIL ───────────────────────────────────────────────────
//   function setActiveThumbnail(slide) {
//     /*if (!slide) return;
//     const slickIndex = parseInt(slide.getAttribute('data-slick-index'), 10);
//     document.querySelectorAll('#previewsGallery .slick-slide')
//       .forEach(s => s.classList.remove('active', 'slick-current'));
//     slide.classList.add('active', 'slick-current');
//     if (!isNaN(slickIndex) && typeof $ !== 'undefined') {
//       try { $('#previewsGallery').slick('slickGoTo', slickIndex); } catch (e) {}
//     }*/
//   }

//   // ─── MAIN UPDATE ────────────────────────────────────────────────────────────
//   function updateImageFromSelection() {
//     console.group('[ImageSwitcher] ════ updateImageFromSelection() ════');

//     const { shape, metal, carat } = getSelectedCombo();
//     if (!shape || !metal || !carat) {
//       console.error('❌ Missing dropdown value');
//       console.groupEnd();
//       return;
//     }

//     // 1. Sync variant ID + price
//     syncVariantId(shape, metal, carat);

//     // 2. Find matching slide and update image
//     const altKey = `${metal}-${shape}-${carat}`;
//     const slide  = findSlideByAlt(altKey);
//     if (!slide) { console.groupEnd(); return; }

//     const imageUrl = slide.getAttribute('data-image');
//     const zoomUrl  = slide.getAttribute('data-zoom-image');
//     const imgEl    = slide.querySelector('img');
//     const altText  = imgEl?.alt || altKey;

//     _correctImageUrl = imageUrl;
//     _correctZoomUrl  = zoomUrl;
//     _correctAltText  = altText;

//     applyImageToDom(imageUrl, zoomUrl, altText);
//     setTimeout(() => applyImageToDom(imageUrl, zoomUrl, altText), 50);
//     setTimeout(() => applyImageToDom(imageUrl, zoomUrl, altText), 150);
//     setTimeout(() => applyImageToDom(imageUrl, zoomUrl, altText), 300);
//     setTimeout(() => applyImageToDom(imageUrl, zoomUrl, altText), 600);

//     setActiveThumbnail(slide);
//     console.log('🎉 Done!');
//     console.groupEnd();
//   }

//   // ─── PATCH setPrice() ───────────────────────────────────────────────────────
//   function patchSetPrice() {
//     if (typeof window.setPrice === 'function') {
//       window._originalSetPrice = window.setPrice;
//       window._patchedSetPrice  = true;
//       window.setPrice = function () {
//         console.log('[ImageSwitcher] ⚡ setPrice() intercepted');
//         window._originalSetPrice.apply(this, arguments);
//         setTimeout(updateImageFromSelection, 50);
//         setTimeout(updateImageFromSelection, 200);
//       };
//       console.log('[ImageSwitcher] ✅ setPrice() patched');
//     } else {
//       setTimeout(patchSetPrice, 200);
//     }
//   }

//   // ─── PATCH updateData() ─────────────────────────────────────────────────────
//   function patchUpdateData() {
//     if (typeof window.updateData === 'function') {
//       const _original = window.updateData;
//       window.updateData = function () {
//         console.log('[ImageSwitcher] ⚡ updateData() intercepted');
//         _original.apply(this, arguments);
//         setTimeout(updateImageFromSelection, 50);
//         setTimeout(updateImageFromSelection, 200);
//         setTimeout(updateImageFromSelection, 400);
//       };
//       console.log('[ImageSwitcher] ✅ updateData() patched');
//     } else {
//       console.warn('[ImageSwitcher] ⚠️ updateData() not found');
//     }
//   }

//   // ─── ATTACH DROPDOWN LISTENERS ──────────────────────────────────────────────
//   function attachDropdownListeners() {
//     const selectors = [
//       '.option-supported-shapes select',
//       '.option-metal-color select',
//       '.option-head-sizes select'
//     ];
//     selectors.forEach(sel => {
//       const el = document.querySelector(sel);
//       if (el) {
//         el.addEventListener('change', function (e) {
//           console.log('[ImageSwitcher] 🖱️ Dropdown changed:', sel, '→', e.target.value);
//           // Reset thumb flag on dropdown change so observer is active
//           _thumbClicked = false;
//           updateImageFromSelection();
//           filterGallerySlides();
//           setTimeout(updateImageFromSelection, 50);
//           setTimeout(updateImageFromSelection, 150);
//           setTimeout(updateImageFromSelection, 300);
//           setTimeout(updateImageFromSelection, 600);
//         });
//         console.log('[ImageSwitcher] 👂 Listener on:', sel);
//       } else {
//         console.error('[ImageSwitcher] ❌ Not found:', sel);
//       }
//     });
//   }

//   // ─── INIT ────────────────────────────────────────────────────────────────────
//   function init() {
//     console.group('[ImageSwitcher] 🔄 init()');
//     patchSetPrice();
//     patchUpdateData();
//     attachDropdownListeners();
//     attachThumbnailListeners(); // ← NEW
//     startObserver();

//     setTimeout(function () {
//       captureSlickSettings();
//       updateImageFromSelection();
//       filterGallerySlides();
//       startObserver();
//     }, 600);

//     console.groupEnd();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     setTimeout(init, 300);
//   }

//   // ─── EXPOSE DEBUG TOOLS ──────────────────────────────────────────────────────
//   window.ImageSwitcherDebug = {
//     update:      updateImageFromSelection,
//     filterGallery: filterGallerySlides,
//     startWatch:  startObserver,
//     getStored:   () => ({ url: _correctImageUrl, zoom: _correctZoomUrl, alt: _correctAltText }),
//     getVariant:  () => document.querySelector('input[name="id"]')?.value,
//     lookupId:    (shape, metal, carat) => getVariantData(shape, metal, carat),
//     testPrice:   (shape, metal, carat) => updatePriceDisplay(getVariantData(shape, metal, carat)),
//   };

// })();